import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import noScroll from 'no-scroll';
import { PageHeader } from '../PageHeader';
import { BackButtonIconEnum } from '../PageHeader/types';
import { Backdrop, Sheet } from './styled';

interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  height: number | string;
  children: React.ReactNode;
}

export const BottomSheet: React.FC<BottomSheetProps> = ({
  isOpen,
  onClose,
  title,
  height,
  children
}) => {
  useEffect(() => {
    if (!isOpen) return;
    noScroll.on();
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    return () => {
      noScroll.off();
      document.removeEventListener('keydown', onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen || typeof document === 'undefined') return null;

  return createPortal(
    <>
      <Backdrop onClick={onClose} />
      <Sheet $height={height}>
        <PageHeader
          title={title}
          onClick={onClose}
          icon={BackButtonIconEnum.Close}
          closeButtonAlign="right"
          showHeaderBorder={false}
        />
        {children}
      </Sheet>
    </>,
    document.body
  );
};
